module.exports = __webpack_public_path__ + "static/media/achieve_v2.b4865862.jpg";